<template>
  <div style="width:100%;height:100%;" ref="line"></div>
</template>

<script>
import echarts from "echarts";

function setOption(data) {
  var linearBtoG = {
    type: "linear",
    x: 0,
    y: 0,
    x2: 1,
    y2: 0,
    colorStops: [
      {
        offset: 0,
        color: "#1c98e8"
      },
      {
        offset: 1,
        color: "#28f8de"
      }
    ]
  };
  var areaBtoG = {
    type: "linear",
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [
      {
        offset: 0,
        //81,177,203, 0.6
        //color: "rgba(35,184,210,2)"
        color: "rgba(81,177,203, 1)"
      },
      {
        offset: 1,
        color: "rgba(35,184,210,0)"
      }
    ]
  };

  var option = {
    title: {
      text: data.title,
      textStyle: {
        fontSize: 16,
        color: "#32b6d3",
        fontWeight: "normal",
        fontFamily: "Microsoft YaHei"
      },
      top: "1%",
      left: "2.5%"
    },
    tooltip: {
      trigger: "axis", //触发类型。[ default: 'item' ] :数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用;'axis'坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
      axisPointer: {
        //type: "shadow",
        lineStyle: {
          color: "#57617B"
        }
      }
      //formatter: "{b0}<br />{a0}: {c0}"
    },
    grid: {
      left:  data.gridLeft ? data.gridLeft : "0%", //grid 组件离容器左侧的距离。
      right: data.gridRight ? data.gridRight : "10%", //grid 组件离容器右侧的距离。
      top: data.gridTop ? data.gridTop : "14%",
      bottom: data.gridBottom ? data.gridBottom : "4%", //grid 组件离容器下侧的距离。
      containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ]
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: false, //坐标轴两边留白策略，类目轴和非类目轴的设置和表现不一样
        axisLine: {
          show: true,
          lineStyle: {
            color: "#57617B", //坐标轴线线的颜色。
            width: 1,
            type: "solid"
          }
        },
        splitNumber: 1,
        data: data.xData
      }
    ],
    yAxis: [
      {
        type: "value", //坐标轴类型。'value' 数值轴，适用于连续数据;'category' 类目轴，适用于离散的类目数据，为该类型时必须通过 data 设置类目数据;'time' 时间轴;'log' 对数轴.
        //name: '单位（个）', //坐标轴名称。
        axisTick: {
          show: false //是否显示坐标轴刻度
        },
        axisLine: {
          lineStyle: {
            color: "rgba(81,177,203,1)" //坐标轴线线的颜色
          }
        },
        min: 0,
        //max:100,
        axisLabel: {
          margin: 10, //刻度标签与轴线之间的距离
          formatter: function(val) {
            return val;
          },
          color: "#57617B"
        },
        splitLine: {
          lineStyle: {
            color: "rgba(81,177,203,.4)" //分隔线颜色设置
          }
        }
      }
    ],
    series: [
      {
        name: data.name, //系列名称，用于tooltip的显示，legend 的图例筛选，在 setOption 更新数据和配置项时用于指定对应的系列
        type: "line",
        smooth: true, //是否平滑曲线显示
        symbol: "circle", //标记的图形。ECharts 提供的标记类型包括 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'
        symbolSize: 5, //标记的大小，可以设置成诸如 10 这样单一的数字，也可以用数组分开表示宽和高，例如 [20, 10] 表示标记宽为20，高为10[ default: 4 ]
        showSymbol: true, //是否显示 symbol, 如果 false 则只有在 tooltip hover 的时候显示
        lineStyle: {
          //线条样式
          normal: {
            color: linearBtoG,
            width: 1.7 //线宽。[ default: 2 ]
          }
        },
        areaStyle: {
          //区域填充样式
          normal: {
            color: areaBtoG
            /* color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  //填充的颜色。
                  offset: 0, // 0% 处的颜色
                  color: "rgba(81,177,203, 0.6)"
                },
                {
                  offset: 0.8, // 80% 处的颜色
                  color: "rgba(81,177,203, 0)"
                }
              ],
              false
            ),
            shadowColor: "rgba(0, 0, 0, 0.1)", //阴影颜色。支持的格式同color
            shadowBlur: 10 //图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果
            */
          }
        },
        itemStyle: {
          //折线拐点标志的样式
          normal: {
            color: "rgb(81,177,203)",
            borderColor: "rgba(81,177,203,0.27)", //图形的描边颜色。支持的格式同 color
            borderWidth: 12 //描边线宽。为 0 时无描边。[ default: 0 ]
          }
        },
        data: data.yData
      }
    ]
  };
  return option;
}
export default {
  name: "CsLine",
  props: ["args"],
  methods: {
    initChart() {
      window.addEventListener(
        "resize",
        function() {
          this.myChart.resize();
        }.bind(this)
      );
    },
    resize: function() {
      this.myChart.resize();
    },
    reDrawChart: function(args) {
      var container = this.$el;
      this.initChart();
      this.myChart = echarts.init(container);
      this.myChart.setOption(setOption(args), false);
    }
  },
  mounted: function(el) {
    var container = this.$el;
    this.initChart();
    this.myChart = echarts.init(container);
  },
  watch: {
    args: function(newVal, oldVal) {
      this.args = newVal;
      this.seriesData(this.args.yData);
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/echarts/lineChart.vue